export default "__VITE_ASSET__BaKw6Tgd__"